var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgImportWarning = function SvgImportWarning(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "importWarning_svg__Ebene_1",
    x: 0,
    y: 0,
    viewBox: "0 0 50 50",
    ref: ref
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".importWarning_svg__st0{fill:#414a5f}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.8 27.6c0-.2.1-1 0-1.2-.1-.3-.3-.6-.5-.7-.3-.2-.7-.3-1.1-.2-.7.1-1 .8-1.1 1.4-.3 4.6-5 15.6-14.1 18.8-7.2 2.6-16.9.7-22-4.4-2.1-2-2.3-2.7-2.9-3.7l5.3.9c.4.1.8 0 1.1-.2q.45-.3.6-.9c.2-.8-.3-1.5-1-1.7l-8.6-2.3c-.7-.2-1.5.2-1.7 1L1.6 43c-.1.6.3 1.3.9 1.5.5.2.8.2 1.2 0s.6-.5.8-.8l1.6-4.3c.6.9.8 1.4 1.7 2.7 6.2 7.4 17.4 9.9 26.8 6.2 8.6-4 14-11.7 15.2-20.7",
    className: "importWarning_svg__st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9 32.4c0-1.6 1.2-2.9 2.8-2.9s2.8 1.3 2.8 2.9-1.2 2.9-2.8 2.9-2.8-1.2-2.8-2.9m.6-13.5-.1-3.4c0-.4.3-.8.7-.8h3.2c.4 0 .8.3.7.8l-.1 3.4-.6 8.3c0 .4-.4.7-.7.7h-1.7c-.4 0-.7-.3-.7-.7z",
    className: "importWarning_svg__st0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M.3 22.3c0 .2-.1 1 0 1.2.1.3.3.6.5.7.3.2.7.3 1.1.2.7-.1 1-.8 1.1-1.4.3-4.6 5-15.5 14-18.8 7.2-2.6 16.8-.6 21.9 4.4 2 2 2.3 2.7 2.9 3.7l-5.2-.9c-.4-.1-.7 0-1.1.2q-.45.3-.6.9c-.2.8.3 1.5 1 1.7l8.5 2.3c.7.2 1.5-.2 1.7-1L48.3 7c.1-.6-.3-1.3-.9-1.5-.5-.2-.8-.1-1.2 0-.3.2-.6.4-.7.8l-1.6 4.3c-.6-.9-.8-1.4-1.7-2.7C36 .5 24.8-2 15.4 1.7 6.8 5.6 1.4 13.3.3 22.3",
    className: "importWarning_svg__st0"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgImportWarning);
export default ForwardRef;